import React from 'react';

import {
  TextSelectionToolbar,
  TwitterButton,
} from './../text-selection-toolbar/index.js';
interface Props {
  onButtonClick?: (pluginId: string, action: string, value: string) => void;
  container: HTMLElement;
}

const SelectionToolbar: React.FC<Props> = ({ onButtonClick, container }) => {
  return (
    <TextSelectionToolbar container={container}>
      {selectedText => (
        <TwitterButton
          selectedText={selectedText}
          onClick={selectedText => onButtonClick?.('TWITTER', 'Click', selectedText)}
        />
      )}
    </TextSelectionToolbar>
  );
};

export default SelectionToolbar;
